<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col class="text-center title">線上點餐管理 / 商品加購設定</b-col>
    </b-row>

    <div id="func-content">
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="p-4 box-shadow">
              <div class="row">
                <label class="control-label col-md-2 mt-2">品牌：</label>
                <div class="col-md-4">
                  <select
                        id="brands-code"
                        name="brandsCode"
                        class="form-control"
                        v-model="search.brandCode"
                      >
                      <option
                        v-for="x in selectListBrands"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Text}}</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-12">
                    <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit_APP">
                                                <div class='float-right'>
                                                    <div class='float-right'>
                                                        <table>
                                                            <tr>
                                                                <td v-if='!btn_add' colspan="3">
                                                                    <label>{{editOldAppTypeName}}</label>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td v-if='!btn_add'>
                                                                    <label>{{iAppTypeStatusDesc}}{{afterClickBrandsCode}}加購品：</label>
                                                                </td>
                                                                <td v-if='!btn_add'>
                                                                    <validate tag="div">
                                                                        <multiselect v-model="product" :options="products" :multiple="false" :custom-label="nameWithLang" group-values="Detail" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" :show-labels="false">
                                                                            <span slot="noResult">查無資料</span>
                                                                        </multiselect>
                                                                        <div class="text-danger" v-if="valid_product&&!product">{{valid_product}}</div>
                                                                    </validate>
                                                                </td>
                                                                <td>
                                                                    <button type='button' class='btn btn-outline-light' v-show='btn_order && btn_add && FunctionPermission > 1' @click='addAppTypeBy'>新增加購品</button>
                                                                    <button type='button' class='btn btn-warning text-white' v-show='btn_order && btn_add && FunctionPermission > 1' @click='editOrderBy'>重新排序</button>

                                                                    <button type='submit' class='btn btn-save' v-show='!btn_add && FunctionPermission > 1'>儲存</button>
                                                                    <button type='reset' class='btn btn-clear' v-show='!btn_add && FunctionPermission > 1' @click='editAppTypeCancel'>取消</button>
                                                                    <!-- 排序用按鈕 -->
                                                                    <button type='button' class='btn btn-save' v-show='!btn_order && FunctionPermission > 1' @click='orderAppType'>儲存</button>
                                                                    <button type='button' class='btn btn-clear' v-show='!btn_order && FunctionPermission > 1' @click='orderAppTypeCancel'>取消</button>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </vue-form>
                  </div>
                  <div class="col-lg-12 mt-2">

                    <table id='AppTypeTable' class='table table-bordred table-striped'>
                                                <thead>
                                                    <tr>
                                                        <th style="width:10%">序號</th>
                                                        <th style="width:10%">品牌</th>
                                                        <th style="width:20%">代碼</th>
                                                        <th style="width:30%">商品名稱</th>
                                                        <th style="width:25%">POS分類</th>
                                                        <th style="width:5%"></th>
                                                    </tr>
                                                </thead>
                                                <draggable v-model='listAppType' element='tbody' :options="dragOptions">
                                                    <tr v-for='(x, index) in listAppType' :key='x.ID'>
                                                        <td>{{index + 1}}</td>
                                                        <td>{{x.BrandCode}}</td>
                                                        <td>{{x.ProductCode}}</td>
                                                        <td>{{x.Name}}</td>
                                                        <td>{{x.AttributeName}}</td>
                                                        <td><button v-if='!x.hasdetail' class='btn-circle btn-circle-ptc1' v-show='FunctionPermission > 1 && btn_order' @click='delAppTypeByOpen(index)'><span class='fas fa-trash-alt' title="刪除"></span></button>
                                                        </td>
                                                    </tr>
                                                </draggable>
                                            </table>
                                        <b-modal ref='editAppTypeModal' hide-footer :title='modalTitleForAPPType'>
                                            <b-container fluid>
                                                <div class='row mt-3' style='text-align:center;'>
                                                    <label class='control-label'>確認{{this.iAppTypeStatusDesc}}「{{this.editAppTypeName}}」?</label>
                                                </div>
                                                <div class='float-right'>
                                                    <b-btn variant='primary' @click='editAppTypeModalSave'>確認</b-btn>
                                                    <b-btn variant='secondary' @click='editAppTypeModalCancel'>取消</b-btn>
                                                </div>
                                            </b-container>
                                        </b-modal>
                  </div>
                </div>

          </div>
        </div>
      </b-card>

      <!-- 預覽畫面Modal -->
      <b-modal ref="mdDetail" hide-footer hide-header>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12 block">
              <img class="front_img" src="../../../assets/preview/phone.png">
              <div class="bk_div">
                <img class="bk_img" :src="md_imgUrl">
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>

      <!-- ReSort Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="排序變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定 {{sort_action==1? '放棄' : '儲存'}} 排序變更 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="confirm2">確定</b-btn>
              <b-btn variant="secondary" @click="cancel2">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import miniToastr from 'mini-toastr'
import draggable from 'vuedraggable'
import VModal from 'vue-js-modal'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
miniToastr.init()

export default {
  components: {
    draggable,
    Multiselect
  },
  data () {
    return {
      search: {
        brandCode: DEFAULT_SEARCH_BRAND_CODE
      },
      isReSort: false,
      sort_action: 1,
      sort_list: [],
      md_id: 0,
      API_URL: API_URL,
      FunctionPermission: 0,
      //-------APP分類設定 (AppType)-------------start
      sort_disabled: true, // 排序功能是否停用
      listAppType: [], // 列表
      modalTitleForAPPType: "", // APP分類設定 - Modal的title
      btn_order: true, // 上方[重新排序]按鈕是否顯示
      btn_add: true, // 上方[新增APP分類按鈕]按鈕是否顯示
      // 上方編輯功能
      formstate: {}, // 驗證用
      iAppTypeStatusDesc: "", // 是新增or修改or刪除
      iAppTypeStatus: 0, // 新增or修改or刪除
      editAppTypeName: "", // Input APP分類名稱
      editOldAppTypeName: "", // 原APP分類名稱
      editAppTypeID: "", // 目前編輯/刪除的ID
      //-------APP分類設定 (AppType)-------------end
      products: [], // 商品清單
      product: '', // 新增商品
      valid_product: '',
      selectListBrands: [],
      afterClickBrandsCode: "",
    }
  },
  created () {
    this.querySelectListBrands()
    this.FunctionPermission = getFunctionPermission('F19') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }
    this.query()
  },
  methods: {
    reset () {
      this.search.brandCode = DEFAULT_SEARCH_BRAND_CODE

      this.query()
    },
    btnQuery () {
      this.query()
    },
    query () {
      this.isReSort = false
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getPlus/v1', {
        BrandCode: this.search.brandCode
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.listAppType = response.data.data
          if (response.data.result === '0000') {
            this.listAppType = response.data.data
            this.afterClickBrandsCode = this.search.brandCode
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.listAppType = []
            miniToastr.error(response.data.message, '資料讀取異常')
            // console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error('5')
          this.listAppType = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    resort () {
      this.query(2)
      this.sort_list = []
      this.isReSort = true
    },
    dragEnd (e) {
      this.sort_list = []
      var childs = Array.from(e.to.getElementsByTagName("tr"))
      childs.forEach((value) => {
        this.sort_list.push(value.id)
      })
    },
    cancel () {
      if (this.sort_list.length === 0) {
        this.query()
      } else {
        this.sort_action = 1
        this.$refs.mdCheck.show()
      }
    },
    save () {
      if (this.sort_list.length === 0) {
        this.query()
      } else {
        this.sort_action = 2
        this.$refs.mdCheck.show()
      }
    },
    cancel2 () {
      this.$refs.mdCheck.hide()

      if (this.sort_action === 2) {
        this.query()
      }
    },
    confirm2 () {
      this.$refs.mdCheck.hide()

      if (this.sort_action === 1) {
        this.query()
      } else {
        this.$parent.Loading = true
        return axios.post(API_URL + '', {
          arrSort: this.sort_list
        })
          .then((response) => {
            this.$store.commit('TOKEN', response.data.jwt)
            this.$parent.Loading = false

            if (response.data.result === '0000') {
              miniToastr.success('首頁排序已變更')
              this.query()
            } else if (response.data.result === '0006') {
              this.$parent.logOut(true, true)
            } else {
              miniToastr.error(response.data.message, '資料變更錯誤')
              console.log(response.data.message)
            }
          })
          .catch((error) => {
            this.$parent.Loading = false
            miniToastr.error(error, '資料變更錯誤')
            console.log(error)
          })
      }
    },
    onSubmit_APP: function () {
      this.modalTitleForAPPType = "新增" + this.afterClickBrandsCode + "加購品";
      this.valid_errMsg = false
      if (!this.product) {
        this.valid_errMsg = true
        this.valid_product = '請選擇加購品'
      }
      if (this.valid_errMsg) {
      } else {
        this.editAppTypeName = this.product.Name
        this.openEditAppTypeModal()
      }
    },
    // APP分類設定 - Modal的增刪改
    editAppTypeModalSave () {
            if (!this.btn_add) {
                if (this.iAppTypeStatus === 1) { // 新增
                    this.$parent.Loading = true
                    return axios.post(API_URL + '/web/shopping/plusCreate', {
                        product: this.product,
                        brandCode: this.afterClickBrandsCode
                    })
                        .then((response) => {
                            if (response.data.result === '0000') {
                                miniToastr.success('新增成功')
                                this.editAppTypeModalReset()
                                this.query()
                            } else {
                                if (response.data.result === '0006') {
                                    this.$parent.logOut(false, true)
                                } else {
                                    miniToastr.error(response.data.message, '錯誤訊息')
                                }
                                this.$refs.editAppTypeModal.hide()
                            }
                            this.$parent.Loading = false
                        })
                        .catch((error) => {
                            miniToastr.error(error, 'Error')
                            this.$parent.Loading = false
                        })
                }
            }
            // 刪除
            if (this.iAppTypeStatus === 3) {
              this.$parent.Loading = true
              return axios.post(API_URL + '/web/shopping/plusDelete', {
                  id: this.editAppTypeID
              })
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('刪除成功')
                        this.editAppTypeModalReset()
                        this.query()
                        localStorage.setItem('TOKEN', response.data.jwt)
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                        this.$refs.editAppTypeModal.hide()
                    }
                    this.$parent.Loading = false
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })
            }
    },
    // APP分類設定 - Modal的重設
        editAppTypeModalReset () {
            this.btn_add = true;
            this.btn_order = true;
            this.editAppTypeName = "";
            this.product = "";
            this.$refs.editAppTypeModal.hide();
        },
        // APP分類設定 - Modal的取消
        editAppTypeModalCancel () {
            this.$refs.editAppTypeModal.hide();
        },
    // APP分類設定 - 按下[新增APP分類]按鈕
    addAppTypeBy () {
      this.iAppTypeStatus = 1;
      this.iAppTypeStatusDesc = "新增";
      this.btn_add = false;
      this.product = "";
      this.editOldAppTypeName = "";
      if (this.afterClickBrandsCode != this.search.brandCode){
        this.query()
      }
      this.getAllProducts()
    },
    //APP分類設定 - 按下列表刪除按鈕
    delAppTypeByOpen (index) {
      this.iAppTypeStatus = 3;
      this.iAppTypeStatusDesc = "刪除";
      // this.iAppTypeIndex = index;
      this.editAppTypeID = this.listAppType[index].ID;
      this.editAppTypeName = this.listAppType[index].Name;
      this.modalTitleForAPPType = "刪除加購品";
      this.openEditAppTypeModal()
    },
    // APP分類設定 - 取消
    editAppTypeCancel () {
      this.btn_add = true;
      this.btn_order = true;
      this.product = "";
    },
    // APP分類設定 - 開啟是否要'增/刪/改'詢問視窗
    openEditAppTypeModal () {
      this.$refs.editAppTypeModal.show();
    },
    // APP分類設定 - 按下重新排序按鈕
    editOrderBy () {
      this.btn_order = false;
      this.sort_disabled = false; // 啟用排序
    },
    // APP分類設定 - 儲存新的排序
    orderAppType () {
            // 取得id與新的排序
            var arrAll = []
            this.listAppType.forEach(function (arrRole, Index) {
                arrAll.push({
                    id: arrRole.ID,
                    sort: Index + 1
                })
            })
            // call API
            this.$parent.Loading = true
            return axios.post(API_URL + '/web/shopping/plusOrder/v1', {
                data: arrAll,
                BrandCode: this.search.brandCode
            })
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('重新排序成功')
                        this.sort_disabled = true; // 停用排序
                        this.editAppTypeModalReset()
                        this.query(3)
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                    }
                    this.$parent.Loading = false
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })
    },
    // APP分類設定 - 排序取消
    orderAppTypeCancel () {
      this.btn_add = true;
      this.btn_order = true;
      this.sort_disabled = true; // 停用排序
    },
    // 取得商品類別與明細(含group)
    getAllProducts () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 2,
        hasDelete: false,
        hasExtra: false,
        hasCombo: false,
        brandCode: this.search.brandCode
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.products = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListBrands = []
          this.$parent.Loading = false
          miniToastr.error(error, "資料讀取異常")
          console.log(error)
        })
    }
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      return year + '/' + mon + '/' + day
    },
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min + ':' + sec
    }
  },
  computed: {
        // 排序參數設定
        dragOptions () {
            return {
                disabled: this.sort_disabled,
            }
        },
    }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/plus/List.vue